import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledGlobalSearch,
  StyledSearchWrapper,
  StyledSearchInput,
  StyledResults
} from './GlobalSearch.styles'
import { ClinTheme } from '../../../ClinTheme'
import { ClinIcon } from '../../../components/ClinIcon'
import { ClinIconPathName } from '../../../components/ClinIcon/ClinIcon.paths'
import { ClinSpinner } from '../../../components/ClinSpinner'
import { IAutoSuggestProps } from '../AutoSuggest/AutoSuggest.model'

export const GlobalSearch: FunctionComponent<
  IAutoSuggestProps & { isHeader?: boolean }
> = ({
  query = '',
  suggestions = [],
  isLoading,
  showSuggestions,
  isMenuSearch,
  isHeader = false,
  handleChange,
  handleKeyDown,
  handleEnter,
  handleFocus,
  handleBlur,
  renderSuggestions
}) => {
  const { t } = useTranslation()

  const getClassNames = (isMenuSearch: boolean | undefined) => {
    const baseClasses = {
      resultsClassName: 'clin-global-search-results',
      wrapperClassName: 'clin-global-search-input-wrapper',
      inputClassName: 'clin-global-search-input'
    }

    if (isMenuSearch) {
      return {
        resultsClassName: 'clin-global-search-menu-results',
        wrapperClassName: 'clin-global-search-menu-input-wrapper',
        inputClassName: 'clin-global-search-menu-input'
      }
    }
    return baseClasses
  }

  const { resultsClassName, wrapperClassName, inputClassName } =
    getClassNames(isMenuSearch)

  return (
    <StyledGlobalSearch>
      <StyledSearchWrapper
        className={wrapperClassName}
        onKeyDown={handleKeyDown}
        isHeader={isHeader}
        showSuggestions={showSuggestions}
        hasSuggestions={suggestions.length > 0}
      >
        <StyledSearchInput
          className={inputClassName}
          showSuggestions={showSuggestions}
          autoFocus={false}
          placeholder={t('global_search:global_search_placeholder')}
          value={query}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
              handleEnter?.(e)
            }
          }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          isHeader={isHeader}
        />

        {isLoading ? (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              left: isMenuSearch ? ClinTheme.space[2] : '20px'
            }}
          >
            <ClinSpinner size={ClinTheme.space[3]} />
          </div>
        ) : (
          <ClinIcon
            className="clin-icon search-icon"
            iconName={ClinIconPathName.Search}
          />
        )}
        {showSuggestions &&
          suggestions &&
          renderSuggestions &&
          (() => {
            const content = renderSuggestions(suggestions)
            return content ? (
              <StyledResults
                showSuggestions={showSuggestions}
                isHeader={isHeader}
                className={resultsClassName}
              >
                {content}
              </StyledResults>
            ) : null
          })()}
      </StyledSearchWrapper>
    </StyledGlobalSearch>
  )
}
